module.exports = __webpack_public_path__ + "public/5a8dc96e18bc260360d408860b4c65f3.woff2";